import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import Separator from "@components/CustomTypography/Separator/Separator"
import ImageTextCard from "@components/WebsiteRevamp/ImageTextCard/ImageTextCard"
import Typography, {
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import {
	AdvancedSideAssetMainContent,
	AdvancedSideAssetModuleType,
} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

import styles from "./SecurityFeaturesSection.module.scss"

type Props = {
	data: AdvancedSideAssetModuleType
}

const SecurityFeaturesSection = (props: Props) => {
	return (
		<section>
			<Separator size={128}>
				<ContainerWrapper>
					<Typography
						content={props.data.sectionTitle}
						variant={Variant.SectionTitle}
					/>
					<Separator />
					<div className={styles.cardContainer}>
						{props.data.mainContent?.map(
							(
								element: AdvancedSideAssetMainContent,
								index: number,
							) => {
								return (
									<ImageTextCard
										key={index}
										className={styles.cardBox}
										contentProps={{
											data: element,
										}}
										imageProps={{
											width: 150,
											height: 150,
											style: {
												width: "auto",
												height: "auto",
											},
										}}
									/>
								)
							},
						)}
					</div>
				</ContainerWrapper>
			</Separator>
		</section>
	)
}

export default SecurityFeaturesSection
